module.exports = __webpack_public_path__ + "static/inner_02-4da5084a2739400d04f02b362fea0c87.png";